import { render, staticRenderFns } from "./MessagePreview.html?vue&type=template&id=23076d89&scoped=true&"
import script from "./MessagePreview.js?vue&type=script&lang=js&"
export * from "./MessagePreview.js?vue&type=script&lang=js&"
import style0 from "./MessagePreview.scss?vue&type=style&index=0&id=23076d89&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23076d89",
  null
  
)

export default component.exports